<div class="error-container">
    <h1>Notes App - Error!</h1>
    <p>{{ errorMessage }}</p>
    <a routerLink="/">Go back to home</a>
  </div>
  